import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DuplicateOrdersDialogData {
  duplicateOrderIds: string[];
}

@Component({
  selector: 'hmt-duplicate-orders-dialog',
  templateUrl: './duplicate-orders-dialog.component.html',
  styleUrls: ['./duplicate-orders-dialog.component.scss'],
  standalone: false
})
export class DuplicateOrdersDialogComponent {
  duplicateOrderIds: string[];

  constructor(
    public dialogRef: MatDialogRef<DuplicateOrdersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DuplicateOrdersDialogData
  ) {
    this.duplicateOrderIds = data.duplicateOrderIds || [];
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onContinue(): void {
    this.dialogRef.close(true);
  }
}

